var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative z-10 flex flex-col w-full min-h-screen bg-zinc-100",attrs:{"id":"app"}},[_c('MainLoading'),_c('MainDialog'),_c('ShopCartDialog'),_c('router-view',{staticClass:"relative z-20 flex-1",on:{"set-meta":_vm.SetMetaData}}),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }